/* eslint-disable jsx-a11y/no-static-element-interactions */
import { faSave, faUndo } from '@fortawesome/pro-solid-svg-icons';
import { Grid, Tab, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FloatingButton } from 'commons/Button/FloatingButton';
import { FloatingButtonMenu } from 'commons/Button/FloatingButtonMenu';
import { DialogType } from 'commons/Dialog/CustomDialog';
import CustomIcon from 'commons/Icon/CustomIcon';
import LocalizedText, { localize } from 'commons/LocalizedText/LocalizedText';
import { LaboAdminDocuments } from 'components/LaboAdmin/LaboAdminDocuments';
import { LaboratorySheet } from 'components/LaboAdmin/LaboratorySheet';
import { LaboUserList } from 'components/LaboAdmin/LaboUserList.jsx';
import { Responsibilities } from 'components/LaboAdmin/Responsibilities';
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/exhaustive-deps */
import { PageContainer } from 'components/PageContainer/PageContainer';
import SkeletonLaboratoryGrid from 'components/Skeletons/SkeleronLaboratoryGrid/SkeletonLaboratoryGrid';
import SkeletonLaboratoryCard from 'components/Skeletons/SkeletonLaboratoryCard/SkeletonLaboratoryCard';
import { useDialog } from 'hook/DialogProvider';
import useFetch from 'hook/UseFetch';
import useLocalizedSnackBar from 'hook/UseLocalizedSnackBar';
import useQueryState from 'hook/UseQueryState';
import { useUserInfo } from 'hook/UseUserInfo';
import React, { Suspense, useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { CountryService } from 'services/CountryService';
import { LaboratoryService } from 'services/LaboratoryService';
import { ProgramService } from 'services/ProgramService';
import { UserService } from 'services/UserService';
import { ErrorName } from 'utils/constants/error.name';
import { ParamTypes } from 'utils/constants/param.type';
import { isLaboAdmin } from 'utils/constants/roles';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';
import { GET_LABO_ADMIN_TABS, LABO_ADMIN_TABS_OBJECT } from 'utils/constants/tabs';
import { QueryStringToJSONObject } from 'utils/helpers/QueryStringHelper';

const LABO_ADMIN_TAB = {
  LABORATORY_SHEET_TAB: 0,
  DOCUMENTS_TAB: 1,
  RESPONSIBILITES_TAB: 2,
  USERS_TAB: 3
};

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '40px 0'
  },
  tabs: {
    marginBottom: '10px'
  },
  tab: {
    minHeight: 67,
    minWidth: 50,
    padding: '3px 10px',
    fontSize: '112%',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.menuHover
    },
    '& .MuiTab-wrapper > *:first-child': {
      marginBottom: 3
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '95%'
    }
  },
  controlsContainer: {
    position: 'absolute',
    left: '90%',
    bottom: '15%',
    textAlign: 'center',
    width: '5%'
  },
  saveContainer: {
    cursor: 'pointer',
    position: 'absolute',
    height: 90,
    width: 90,
    fontSize: '200%'
  },
  returnContainer: {
    cursor: 'pointer',
    bottom: 20,
    left: '69%',
    position: 'absolute',
    fontSize: '150%',
    backgroundColor: theme.palette.background.paper
  },
  saveIcon: {
    color: theme.palette.background.paper
  },
  returnIcon: {
    color: theme.palette.primary.main
  },
  loadingSave: {
    position: 'absolute',
    left: '62%'
  },
  noOverflow: {
    maxWidth: '100%'
  }
}));

export const LaboAdminPage = () => {
  const classes = useStyles();
  const { laboratory } = useParams();
  const history = useHistory();
  const showDialog = useDialog();
  const showSnackbar = useLocalizedSnackBar();
  const [tabSelected, setTabSelected] = useQueryState(
    'tabSelected',
    QueryStringToJSONObject(window.location.search.substring(1)).tabSelected || 0,
    ParamTypes.NUMBER
  );
  const adminTabs = GET_LABO_ADMIN_TABS();
  const { role } = useUserInfo();
  const [laboratoryInfo, setLaboratoryInfo] = useState(null);
  const [isLoadingLaboratoryInfo, setIsloadingLaboratoryInfo] = useState(false);
  const [isLoadingSave, setIsloadingSave] = useState(false);
  const {
    response: countries,
    isLoading: isLoadingCountries
  } = useFetch(() => CountryService.getCountries(), []);
  const [usersWithResponsibilities, setUsersWithResponsibilities] = useState([]);
  const [isLoadingUsersWithResponsibilities, setIsLoadingUsersWithResponsibilities] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [isLoadingPrograms, setIsLoadingPrograms] = useState(false);
  const [laboUsers, setlaboUsers] = useState([]);
  const [isLoadingLaboUsers, setIsLoadingLaboUsers] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorFax, setErrorFax] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [laboratorySheetHasChanges, setLaboratorySheetHasChanges] = useState(false);
  const [laboratoryAdminDocHasChanges, setLaboratoryAdminDocHasChanges] = useState(false);
  const [responsibilitiesHasChanges, setResponsibilitiesHasChanges] = useState(false);
  const [laboratoryUserListHasChanges, setLaboratoryUserListHasChanges] = useState(false);
  const [changedFields, setChangedFields] = useState([]);

  const getLaboUsersWithProgramResponsibilities = () => {
    setIsLoadingUsersWithResponsibilities(true);
    UserService.getLaboUsersWithProgramResponsibilities(laboratory)
      .then(usersWithRespResponse => {
        setUsersWithResponsibilities([...usersWithRespResponse]);
        setIsLoadingUsersWithResponsibilities(false);
        setIsLoadingLaboUsers(true);
        UserService.getLaboUsers(laboratory)
          .then(laboUsersResponse => {
            setIsLoadingLaboUsers(false);
            setlaboUsers(laboUsersResponse);
          });
      });
  };

  useEffect(() => {
    if (!isLaboAdmin(role)) {
      history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: ErrorName.UNAUTHORIZED_ACTION });
    }
  },[role])

  useEffect(() => {
    getLaboUsersWithProgramResponsibilities();
  }, []);

  useEffect(() => {
    setIsLoadingPrograms(true);
    ProgramService.getProgramsByLaboratoryId(laboratory)
      .then(programsResponse => {
        setPrograms(programsResponse);
        setIsLoadingPrograms(false);
      });
  }, []);

  const getLaboratoryInfo = () => {
    setIsloadingLaboratoryInfo(true);
    LaboratoryService.getLaboratoryInfo(laboratory)
      .then(response => {
        setLaboratoryInfo(response);
        setIsloadingLaboratoryInfo(false);
      })
      .catch(errorMessage => {
        if (errorMessage !== ErrorName.ABORT_ERROR) {
          showDialog({
            variant: DialogType.ERROR,
            title: localize('error'),
            description: errorMessage
          });
          history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: errorMessage });
        }
      });
  };

  const addAsteriskToTabName = useCallback(currentTab => {
    if ((currentTab.LABEL === LABO_ADMIN_TABS_OBJECT.LABORATORY_SHEET.LABEL && laboratorySheetHasChanges)
      || (currentTab.LABEL === LABO_ADMIN_TABS_OBJECT.DOCUMENTS.LABEL && laboratoryAdminDocHasChanges)
      || (currentTab.LABEL === LABO_ADMIN_TABS_OBJECT.RESPONSIBILITIES.LABEL && responsibilitiesHasChanges)
      || (currentTab.LABEL === LABO_ADMIN_TABS_OBJECT.USERS.LABEL && laboratoryUserListHasChanges)) {
      return '*';
    }
    return '';
  }, [laboratorySheetHasChanges, laboratoryAdminDocHasChanges, responsibilitiesHasChanges, laboratoryUserListHasChanges]);

  useEffect(() => {
    getLaboratoryInfo();
  }, []);

  const handleChangeTab = useCallback((_, tab) => setTabSelected(tab), []);

  const handleOnChange = (value, fields) => {
    const changedFieldsTmp = [...changedFields];
    !changedFieldsTmp?.includes(fields.at(-1)) && changedFieldsTmp.push(fields.at(-1));
    setChangedFields(changedFieldsTmp);
    switch (tabSelected) {
    case LABO_ADMIN_TAB.LABORATORY_SHEET_TAB:
      const laboratoryInfoTmp = { ...laboratoryInfo };
      if (fields.length > 1) {
        laboratoryInfoTmp[fields[0]][fields[1]] = value;
      } else {
        laboratoryInfoTmp[fields[0]] = value;
      }
      setLaboratoryInfo(laboratoryInfoTmp);
      setLaboratorySheetHasChanges(true);
      break;
    case LABO_ADMIN_TAB.DOCUMENTS_TAB:
      setLaboratoryAdminDocHasChanges(true);
      break;
    case LABO_ADMIN_TAB.RESPONSIBILITES_TAB:
      setResponsibilitiesHasChanges(true);
      break;
    case LABO_ADMIN_TAB.USERS_TAB:
      setLaboratoryUserListHasChanges(true);
      break;
    default:
      break;
    }
  };

  const handleSave = () => {
    if (laboratorySheetHasChanges) {
      setIsloadingSave(true);
      LaboratoryService.modifyLaboratoryInfo(laboratory, laboratoryInfo)
        .then(() => {
          showSnackbar('laboratoryInfoModified', { variant: 'success' });
          setIsloadingSave(false);
        })
        .catch(errorMessage => {
          if (errorMessage !== ErrorName.ABORT_ERROR) {
            showDialog({
              variant: DialogType.ERROR,
              title: 'error',
              description: 'errorWhileModifyingLaboratoryInfo'
            });
          }
          setIsloadingSave(false);
        });
      setLaboratorySheetHasChanges(false);
    }
    if (laboratoryAdminDocHasChanges) {
      setLaboratoryAdminDocHasChanges(false);
    }
    if (responsibilitiesHasChanges) {
      UserService.modifyUsersResponsibilities(laboratory, usersWithResponsibilities)
        .then(() => {
          showSnackbar('responsibilitesModified', { variant: 'success' });
          setIsloadingSave(false);
          getLaboUsersWithProgramResponsibilities();
        })
        .catch(errorMessage => {
          if (errorMessage !== ErrorName.ABORT_ERROR) {
            showDialog({
              variant: DialogType.ERROR,
              title: 'error',
              description: 'errorWhileModifyingResponsibilities'
            });
          }
          setIsloadingSave(false);
        });
      setResponsibilitiesHasChanges(false);
    }
    if (laboratoryUserListHasChanges) {
      setLaboratoryUserListHasChanges(false);
    }
    setChangedFields([]);
  };

  const handleReturn = () => {
    switch (tabSelected) {
    case LABO_ADMIN_TAB.LABORATORY_SHEET_TAB:
      getLaboratoryInfo();
      break;
    case LABO_ADMIN_TAB.RESPONSIBILITES_TAB:
      getLaboUsersWithProgramResponsibilities();
      break;
    default:
      break;
    }
  };

  return (
    isLaboAdmin(role)
    && (
      <>
        <PageContainer>
          <Grid container direction="column">
            <Grid item>
              <Tabs
                centered
                classes={{ root: classes.tabs }}
                indicatorColor="secondary"
                onChange={handleChangeTab}
                textColor="secondary"
                value={tabSelected}
                variant="fullWidth"
              >
                {adminTabs.map((currentTab) => (
                  <Tab
                    classes={{
                      root: classes.tab
                    }}
                    icon={<CustomIcon icon={currentTab.ICON} size="lg"/>}
                    key={currentTab.LABEL}
                    label={<LocalizedText className="bold" suffix={`${addAsteriskToTabName(currentTab)}`}
                      text={`${currentTab.LABEL}`}/>}
                  />
                ))}
              </Tabs>
            </Grid>
            <Grid classes={{root: classes.noOverflow}} item >
              <Suspense fallback={SkeletonLaboratoryCard()}>
                {[
                  !isLoadingLaboratoryInfo ?
                    <LaboratorySheet
                      changedFields={changedFields}
                      countries={countries}
                      errorEmail={errorEmail}
                      errorFax={errorFax}
                      errorPhone={errorPhone}
                      handleOnChange={handleOnChange}
                      isLoading={isLoadingCountries}
                      laboratoryInfo={laboratoryInfo}
                      setErrorEmail={setErrorEmail}
                      setErrorfax={setErrorFax}
                      setErrorPhone={setErrorPhone}
                    />
                    :
                    <SkeletonLaboratoryGrid className={classes.container}/>,
                  <LaboAdminDocuments
                    changedFields={changedFields}
                  />,
                  <Responsibilities
                    changedFields={changedFields}
                    isLoadingLaboUsers={isLoadingLaboUsers}
                    isLoadingPrograms={isLoadingPrograms}
                    isLoadingUsersWithResponsibilities={isLoadingUsersWithResponsibilities}
                    laboUsers={laboUsers}
                    programs={programs}
                    setResponsibilitiesHasChanges={setResponsibilitiesHasChanges}
                    setUsersWithResponsibilities={setUsersWithResponsibilities}
                    usersWithResponsibilities={usersWithResponsibilities}
                  />,
                  <LaboUserList
                    changedFields={changedFields}
                  />
                ][tabSelected]}
              </Suspense>
            </Grid>
          </Grid>
        </PageContainer>
        <FloatingButtonMenu>
          <FloatingButton
            icon={faUndo}
            onClick={handleReturn}
            tooltip={<LocalizedText>reset</LocalizedText>}
          />
          <FloatingButton
            disabled={errorEmail || errorPhone}
            icon={faSave}
            isLoading={isLoadingSave}
            isMainButton={true}
            onClick={handleSave}
            tooltip={<LocalizedText>save</LocalizedText>}
          />
        </FloatingButtonMenu>
      </>
    )
  );
};